import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;
